<template>
  <q-popup-edit
      persistent
      buttons
      v-model="Sale_PayReceive"
      @save="(val) => setMoneyBack(val)"
  >
    <q-field
        v-model="Sale_PayReceive"
        mask="currency"
        label="مبلغ دریافتی"
        label-color="indigo"
        autofocus
        filled
        dir="ltr"
        lazy-rules
        :rules="[
                 val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'مبلغ دریافتی را وارد نمایید',
                 val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'مبلغ دریافتی عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
        ]">
      <template v-slot:control="{ id, floatingLabel, value, emitValue }">
        <input :id="id" class="q-field__native text-right" :value="value"
               @change="e => emitValue(e.target.value)"
               v-money="moneyFormatForDirective"
               v-show="floatingLabel">
      </template>
    </q-field>
    <q-input dir="ltr" filled v-model="Sale_PayDate" mask="date" :rules="['date']"
             label="تاریخ پرداخت" clearable>
      <template v-slot:append>
        <q-icon name="event" class="cursor-pointer">
          <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
            <q-date v-model="Sale_PayDate" calendar="persian">
              <div class="row items-center justify-center">
                <q-btn v-close-popup label="تایید" color="primary" flat/>
                <q-btn v-close-popup @click="setToDay()" label="امروز" color="primary"
                       flat/>
              </div>
            </q-date>
          </q-popup-proxy>
        </q-icon>
      </template>
    </q-input>
  </q-popup-edit>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "InvoiceSettlement",
  props: {
    saleNum: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      Sale_PayReceive: 0,
      Sale_PayDate: '',
      moneyFormatForDirective: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
    }
  },
  methods: {
    ...mapActions({
      MoneyBackAction: 'Orders/receiveFactorPay',
    }),
    setMoneyBack(val) {
      if (!val.replaceAll(',', '') || val.replaceAll(',', '') === '0' || !this.Sale_PayDate || this.Sale_PayDate.trim() === '') {
        this.$q.notify({
          message: `کلیه اطلاعات خواسته شده را وارد کنید`,
          color: 'negative',
          position: 'top',
          type: 'negative'
        });
      } else {
        this.MoneyBackAction({
          saleNum: this.saleNum,
          Sale_PayDay: val.replaceAll(',', ''),
          Sale_PayDate: this.Sale_PayDate
        }).then(() => {
          this.$q.notify({
            message: `رسید پرداخت فاکتور ${this.saleNum} ثبت گردید`,
            color: 'positive',
            position: 'top',
            type: 'positive'
          });
          this.Sale_PayReceive = val
        })
      }
    },
    setToDay() {
      this.Sale_PayDate = this.ToJalaliDate(new Date())
    }
  },
  created() {
  }
}
</script>

<style scoped>

</style>